// Treats shop list — every treat row with price + owned, click → buy.
// flashTreatRow() is still imperative DOM ops (briefly toggles a CSS class
// on the row that buy() just touched); the row identity comes from data-id.
import { render } from 'preact';
import { TREATS } from '../content/treats.js';
import { state } from '../systems/state.js';
import { priceOf, meetsRequirement } from '../systems/rate.js';
import { fmt } from '../systems/util.js';
import { useStore } from './use-store.js';

let onBuy = null;

function TreatRow({ t }) {
  useStore();
  const owned = state.owned[t.id] || 0;
  const maxedOut = t.max && owned >= t.max;
  const reqMet = meetsRequirement(t);
  let cls = 'treat';
  if (maxedOut || !reqMet) cls = 'treat maxed';
  else cls = 'treat ' + ((state.count >= priceOf(t)) ? 'affordable' : 'locked');
  const price = priceOf(t);
  return (
    <div className={cls} data-id={t.id} onClick={() => onBuy && onBuy(t)}>
      <div className="icon">{t.icon}</div>
      <div className="info">
        <div className="name">{t.name}</div>
        <div className="desc">{t.desc}</div>
      </div>
      <div className="meta">
        <div className="price">{maxedOut || !reqMet ? '' : fmt(price)}</div>
        <div className="owned">{owned ? `×${owned}` : ''}</div>
      </div>
    </div>
  );
}

function TreatList() {
  return (
    <>
      {TREATS.map(t => <TreatRow key={t.id} t={t} />)}
    </>
  );
}

// Old API: buildTreatRows(onBuyCb) is the boot-time wiring. Keep the
// signature so main.js doesn't need to change its boot order.
export function buildTreatRows(onBuyCb) {
  onBuy = onBuyCb;
  render(<TreatList />, document.getElementById('treats'));
}

// Flash effect on a row after buy. Still imperative — preact doesn't model
// "trigger this animation on this specific row this one time" well, and
// the data-id selector matches what buildTreatRows emits.
export function flashTreatRow(id) {
  const el = document.querySelector(`#treats .treat[data-id="${id}"]`);
  if (!el) return;
  el.classList.remove('buy-flash');
  void el.offsetWidth;
  el.classList.add('buy-flash');
  setTimeout(() => el.classList.remove('buy-flash'), 400);
}

